/**
 * Load Instagram embed.js and run Embeds.process(). Shared so both
 * InstaEmbedByLink (URL-only) and Embed (blockquote HTML) can use it.
 */
const SCRIPT_URL = "https://www.instagram.com/embed.js";
const STORE = typeof window !== "undefined" ? window : {};
const STORE_KEY = "__j6_instagram_embed_loaded";

function loadScript(url) {
  if (!STORE[STORE_KEY]) STORE[STORE_KEY] = {};
  const store = STORE[STORE_KEY];
  if (store[url] && store[url].loaded)
    return Promise.resolve({ loaded: true });
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.async = true;
    script.onload = () => {
      store[url] = { loaded: true };
      resolve({ loaded: true });
    };
    script.onerror = () => resolve({ loaded: false });
    document.head.appendChild(script);
  });
}

export function loadInstagramEmbedJs() {
  if (typeof window === "undefined") return Promise.resolve();
  const runProcess = () => {
    if (window.instgrm) window.instgrm.Embeds.process();
  };
  if (window.instgrm) {
    runProcess();
    return Promise.resolve();
  }
  return loadScript(SCRIPT_URL).then(runProcess);
}
